import { EditIcon } from '$components'
import { clientShowOptions } from '$api-client/@tanstack/react-query.gen'
import { Text, Button, Tooltip, Card } from '$components'
import { useQuery } from '@tanstack/react-query'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { AnimatedOutlet } from '$components'
import { ClientRoutePath } from '$features/clients/routes/protected'
import { Router } from '$utils/router'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'
import { usePageTitle } from '$components'
import { ClientsFilterParam } from '$features/clients/enums/filter-params'

export function DetailsTab() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { hasSubscriptionExpired } = useTenant()

  const { data } = useQuery({
    ...clientShowOptions({
      path: {
        id: Number(id),
      },
      query: {
        include_deleted: true,
        [ClientsFilterParam.IncludeUnapproved]: searchParams.get(ClientsFilterParam.IncludeUnapproved) === '1',
      },
    }),
  })

  const client = data?.data

  usePageTitle(client ? `${client.first_name} ${client.last_name} - Details` : 'Client Details')

  if (!client) {
    return null
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Client Information Card */}
      <Card
        rounding="xl"
        padding="none"
      >
        <Card.Header
          padding="sm"
          className="flex justify-between items-center"
        >
          <Text type="h4">
            Details
          </Text>

          {client.approved_at && (
            <Tooltip
              content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
              disabled={!hasSubscriptionExpired}
            >
              <Button
                variant="secondary"
                size="sm"
                onClick={() => navigate(Router.buildRoute(
                  ClientRoutePath.ClientsDetailsEdit,
                ))}
                icon={EditIcon}
                disabled={hasSubscriptionExpired}
              >
                Edit
              </Button>
            </Tooltip>
          )}
        </Card.Header>

        <Card.Content
          padding="sm"
          className="flex flex-col gap-4"
        >
          <div>
            <Card.Label>Email</Card.Label>
            <Text type="s">
              {client.email}
            </Text>
          </div>

          <div>
            <Card.Label>Phone</Card.Label>
            <Text type="s">
              {client.phone}
            </Text>
          </div>

          <div>
            <Card.Label>Internal Notes</Card.Label>
            <Text type="s">
              {client.internal_notes ?? 'No internal notes'}
            </Text>
          </div>
        </Card.Content>
      </Card>

      <AnimatedOutlet />
    </div>
  )
}
